const DEFAULT_FILE_SIZE = 1048576;
const DEFAULT_MAX_SIZE = DEFAULT_FILE_SIZE * 10;

export {
	DEFAULT_FILE_SIZE,
	DEFAULT_MAX_SIZE
}
